module.exports = __webpack_public_path__ + "img/united-kingdom-flag-round-small.05d99a36.png";